import type { Theme } from "@mui/material/styles";

/** Horizontal inset on narrow viewports (1.5rem each side @ 16px root). */
export const CENTER_MODAL_XS_WIDTH = "calc(100% - 3rem)";

export type CenterModalSize = "sm" | "md" | "lg";

const SIZE_TOKENS: Record<
  CenterModalSize,
  { defaultMdWidth: number; titleFontSize: { xs: string; md: string } }
> = {
  sm: {
    defaultMdWidth: 400,
    titleFontSize: { xs: "1.125rem", md: "1.25rem" },
  },
  md: {
    defaultMdWidth: 480,
    titleFontSize: { xs: "1.5rem", md: "2rem" },
  },
  lg: {
    defaultMdWidth: 600,
    titleFontSize: { xs: "1.5rem", md: "2.125rem" },
  },
};

export function getCenterModalSizeTokens(size: CenterModalSize) {
  return SIZE_TOKENS[size];
}

export function resolveCenterModalWidth(
  width: number | { xs?: number | string; md?: number | string } | undefined,
  size: CenterModalSize,
): { xs: string | number; md?: number | string } {
  const { defaultMdWidth } = getCenterModalSizeTokens(size);
  if (typeof width === "number") {
    return { xs: CENTER_MODAL_XS_WIDTH, md: width };
  }
  return { xs: CENTER_MODAL_XS_WIDTH, md: defaultMdWidth, ...(width ?? {}) };
}

/** Default header / content padding (rem). Modals may override via `headerSx` / `contentSx`. */
export function centerModalHeaderBaseSx(_theme: Theme) {
  return {
    px: { xs: "1.25rem", md: "1.5rem" },
    pt: "2rem",
    pb: "1rem",
  } as const;
}

export function centerModalContentBaseSx(_theme: Theme) {
  return {
    px: { xs: "1.25rem", md: "1.5rem" },
    pt: 0,
    pb: 0,
  } as const;
}
